import React from 'react'
import PropTypes from "prop-types";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Dialog from "@material-ui/core/Dialog";


class CodeModal extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Dialog onClose={this.props.setClose} open={this.props.open}>
                <List>
                    {this.props.vocabulary.map(word => <ListItem key={word.term}>{word.term} {word.weight}</ListItem>)}
                </List>
            </Dialog>
        )
    }
}

CodeModal.propTypes = {
    vocabulary: PropTypes.array,
    open: PropTypes.bool,
    setClose: PropTypes.func,
}

export default CodeModal


// WEBPACK FOOTER //
// ./src/components/CodeModal/CodeModal.jsx